<template>
   <div class='confirm-plan'>
      <process-header :step="9" />
      <div class="body">
         <div class="step-title">Summary of selected activities</div>
         <div class='goal' v-for="goal in goals" :key="goal.id">
            <span class='goal-title'>Goal {{ goal.id }}: {{ goal.name }}</span>
            <div v-for='(objective) in goal.objectives' :key='objective.id' class='objective'>
               <div class='objective-head'>
                  <span class='objective-title'>Objective {{ objective.order }} : {{ objective.description }}</span>
               </div>
               <div class="activity" v-for='activity in objective.activities' :key="activity.id">
                  <span style="font-weight: 600;">{{ activity.code }}</span> <span> {{ activity.description }}</span>
               </div>
            </div>
         </div>
         <back-and-continue
            :back-route="{name: 'rankings'}"
            :next-route="{name: 'final-page'}"
         />
      </div>
   </div>
</template>

<script>
import ProcessHeader from "../Header";
import BackAndContinue from '@/components/molecules/Home/Plan/Back&Continue';
import { fetchWithAuthToken } from '../../../../../axios';
import { mapGetters } from 'vuex';

export default {
   name: 'final-page',
   components: {
      ProcessHeader,
      BackAndContinue,
   },
   data()
   {
      return {
         goals: [],
      };
   },
   computed: {
      ...mapGetters('plan', ['getPlan']),
      planId() {
         return this.$route.params.id;
      },
   },
   created()
   {
      fetchWithAuthToken(`api/plan/${this.planId}/sa/`)
      .then(({data: goals}) =>
      {
         this.goals =goals;
      });
   },
   methods: {
   }
}
</script>

<style lang="scss" scoped>
.confirm-plan {
   margin: 0.5em;
   color: $font-color;
   font-family: $primary-font;
   border-radius: 0.3em;

   > .heading {
      padding: 0.6em;
      background: $secondary-bg;
      border-radius: 0.3em;
      text-align: center;
      > .title {
         text-align: center;
         font-size: 1.8em;
      }
      .inputs {
         display: flex;
         flex-direction: column;
         align-items: center;
      }
   }
   .goals {
      padding: 0.5em;
   }
   .body {
      margin-top: 0.5em;
      padding: 0.5em;
      background: $secondary-bg;
      border-radius: 0.3em;
   }
   .step-title {
      font-family: $secondary-font;
      font-weight: 500;
      font-size: 1.05em;
   }
   .goal {
      background: $page-bg;
      padding: 0.5em;
      margin-bottom: 1em;
      border-radius: 5px;
      .goal-title {
         padding: 0.3em 0.2em;
         font-weight: 600;
         margin-bottom: 0.3em;
      }
      .objective {
         padding: 0.2em;
         &:not(:last-child) {
            margin-bottom: .7em;
         }
         border-radius: 5px;
         background: white;
         .objective-head {
            .objective-title {
               font-weight: 600;
               padding: 0.5em 0.2em;
            }
            display: flex;
            justify-content: space-between;
         }
         .activity {
            padding: 0.4em 1em;
         }
      }
   }
   .question {
      text-align: center;
      span {
         font-weight: 600;
      }
   }
   .btn-group {
      display: flex;
      justify-content: flex-start;
      > * {
         margin-right: 0.3em;
         a {
            color:inherit;
         }
         &:last-child {
            margin-right: 0;
         }
      }
   }
}
</style>
